import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Capitalise chaque mot : "jean-pierre" → "Jean-Pierre" */
export function capitalizeName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/(^|[\s'-])(\p{L})/gu, (_, sep, char) => sep + char.toUpperCase());
}
